<template>
    <div class="d-flex justify-content-between align-items-center pt-3">
        <div class="d-flex align-items-center">
            <button class="pagition_button" @click="setPage(1)">&lt;&lt;</button>
            <button class="pagition_button" @click="setPage(actualPage - 1)">&lt;</button>
            <button
                class="pagition_button"
                v-for="page in pages"
                :class="{'pagition_button_active': isActive(page)}"
                @click="setPage(page)"
            >
                {{ page }}
            </button>
            <button class="pagition_button" @click="setPage(actualPage + 1)">></button>
            <button class="pagition_button" @click="setPage(maxPage)">>></button>
            <div class="align-left d-flex ms-5 align-items-center">
                <span class="me-3 text-nowrap">{{ $t("table.pagination.label") }}</span>
                <select v-model="perPageData" class="form-select">
                    <option v-for="pageOption in pageOptions">{{ pageOption }}</option>
                </select>
            </div>
        </div>
        <div>
            <span class="text-end">{{ $t("table.pagination.total", totalRows, [totalRows]) }}</span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        actualPage: { type: Number, default: 0 },
        perPage: { type: Number, default: 10 },
        totalRows: { type: Number, default: 0 },
        maxButtons: { type: Number, default: 5 },
        pageOptions: { type: Array, default: () => [10, 20, 50] },
    },
    data: function () {
        return {
            perPageData: this.perPage,
        }
    },
    created: function () {
        this.setPage(this.actualPage);
    },
    computed: {
        pages: function () {
            var start = this.actualPage - 2;
            var end = this.actualPage + 2;
            if (start <= 0) {
                start = 1;
            }
            if (end > this.maxPage) {
                end = this.maxPage;
            }
            return Array(end - start + 1).fill().map((_, index) => index + start)
        },
        maxPage: function () {
            return Math.ceil(this.totalRows / this.perPage);
        }
    },
    watch: {
        perPageData: function (value) {
            this.$emit('update:perPage', parseInt(value));
        }
    },
    methods: {
        isActive: function (page) {
            return page == this.actualPage;
        },
        setPage: function (page) {
            if (page > this.maxPage) {
                page = this.maxPage;
            }
            if (page <= 0) {
                page = 1;
            }
            this.$emit('update:actualPage', page)
        }
    }
}
</script>

<style lang="scss">
.pagition_button {
    width: 40px;
    height: 40px;
    border-style: solid;
    border-color: #ddd;
    border-width: 1px 0px 1px 1px;
    background-color: transparent;
    color: #888;
    &:first-of-type {
        border-radius: 5px 0px 0px 5px;
    }
    &:last-of-type {
        border-radius: 0px 5px 5px 0px;
        border-width: 1px 1px 1px 1px;
    }
    &:hover {
        background-color: #ddd;
    }
}

.pagition_button_active {
    background-color: #ddd;
}
</style>